export default __webpack_public_path__ + "static/media/partner_01.0b64d403.png";